export enum radioDirectionTypes {
    row = "row",
    col = "col",
}
